(function () {
    'use strict';

    angular.module("imApp").factory("furnitureFabricsColorsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 2118,
                    parameters: parms || {}
                });
            },
            listFurnitureFabricsColors: function (parms) {
                return $ihttp.post({
                    method: 2119,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
